/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProgramGroupCopyRequest
 */
export interface ProgramGroupCopyRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramGroupCopyRequest
     */
    programGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProgramGroupCopyRequest
     */
    targetOrganizationId: string;
}

/**
 * Check if a given object implements the ProgramGroupCopyRequest interface.
 */
export function instanceOfProgramGroupCopyRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "programGroupIds" in value;
    isInstance = isInstance && "targetOrganizationId" in value;

    return isInstance;
}

export function ProgramGroupCopyRequestFromJSON(json: any): ProgramGroupCopyRequest {
    return ProgramGroupCopyRequestFromJSONTyped(json, false);
}

export function ProgramGroupCopyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramGroupCopyRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programGroupIds': json['programGroupIds'],
        'targetOrganizationId': json['targetOrganizationId'],
    };
}

export function ProgramGroupCopyRequestToJSON(value?: ProgramGroupCopyRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'programGroupIds': value.programGroupIds,
        'targetOrganizationId': value.targetOrganizationId,
    };
}

